export const SHARE_LINKS = {
  WHATSAPP: {
    MOBILE: (message: string): string => `whatsapp://send?text=${message}`,
    DESKTOP: (message: string): string => `https://web.whatsapp.com/send?text=${message}`,
  },
  TELEGRAM: {
    MOBILE: (message: string): string => `tg://msg?text=${message}`,
    DESKTOP: (message: string): string => `https://t.me/share/url?url= &text=${message}`,
  },
  FACEBOOK: {
    MOBILE: (message: string, url: string): string =>
      `fb://facewebmodal/f?href=https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    DESKTOP: (message: string, url: string): string =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  LINKEDIN: {
    MOBILE: (message: string, url: string): string =>
      `linkedin://shareArticle?mini=true&url=${encodeURIComponent(url)}`,
    DESKTOP: (message: string, url: string): string => {
      return `https://www.linkedin.com/feed/?shareActive=true&text=${message}`
    },
  },
}
